<cat-result-item [item]="searchItem$ | async"></cat-result-item>
